module.exports = __webpack_public_path__ + "img/HeroAndpostcards-mobile.d9b2977a.jpg";